export const PROJECTS_TABLE_COLUMNS = {
  projectNumber: "Project Number",
  projectName: "Project Name",
  description: "Description",
  projectType: "Project Type",
  status: "Status",
  productCategory: "Product Category",
  requestor: "Requestor",
  platformProject: "Platform Project",
  intangibleAccountingStandard: "Intangible Accounting Standard",
  productLine0: "Product Line 0",
  productLine1: "Product Line 1",
  productLine2: "Product Line 2",
  projectLeaders: "Project Leaders",
  estimatedLaunchDate: "Estimated Launch Date",
  intake: "Intake",
};
